module.exports = __webpack_public_path__ + "img/share_bg1.7ccc361f.png";